const Ajv = require("ajv");
const addFormats = require("ajv-formats");

const ajv = new Ajv({
  strict: false,
  allErrors: true,
  strictRequired: true,
  allowDate: true,
  loopEnum: 60,
  loopRequired: 60,
  ownProperties: true,
  verbose: true // dony set
});
addFormats(ajv);

const schemaSubformulario = {
  type: "array",
  minItems: 1,
  items: {
    type: "object",
    properties: {
      name: {
        type: "string",
        minLength: 3
      },
      type: {
        type: "string",
        minLength: 3,
        enum: ["input", "date", "choice", "boolean", "photo", "geo", "label", "video", "viewer", "datasource"],
        errorMessage: "Este tipo de pregunta no es válida para el subformulario.",
        pathI18n: `FORMS`
      },
      label: {
        type: "string",
        minLength: 3
      },
      required: {
        type: "boolean"
      },
      help: {
        type: "string",
        minLength: 3
      },
      inputType: {
        type: "string",
        minLength: 3,
        enum: [
          "default",
          "email",
          "barcode",
          "phone",
          "textarea",
          "ranking",
          "number",
          "currency",
          "domain",
          "QRReader",
          "calendar",
          "multi",
          "multiOther",
          "radioOther",
          "radio",
          "standar",
          "camera",
          "gallery",
          "gallery/camera",
          "servi",
          "location",
          "label",
          "paragraph",
          "url",
          "web",
          "document",
          "action"
        ]
      },
      key: {
        type: "string",
        minLength: 3
      },
      maxLength: {
        type: "number",
        minimum: 1
      },
      properties: {
        type: "object",
        properties: {
          min: { type: "number" },
          max: { type: "number" },
          default: { type: "string" },
          size: { type: "number" },
          color: { type: "string" },
          orientation: { type: "string" },
          minValue: { type: "number" },
          maxValue: { type: "number" },
          limit: { type: "number" },
          originKey: { type: "string" },
          searchField: { type: "string" }
        },
        additionalProperties: false
      },
      actions: {
        type: "object",
        required: ["id", "mode", "type", "questions"],
        properties: {
          id: { type: "string", maxLength: 32 },
          mode: { type: "string", enum: ["on_trigger", "on_depend", "on_event"] },
          type: { type: "string" },
          operation: {
            type: "string",
            enum: ["add", "sub", "divider", "multiply", "concat", "avg", "mode", "median", "min", "max"],
            description: JSON.stringify({
              type: "string",
              msg: "msgContainerElements"
            })
          },
          questions: {
            type: "array",
            minItems: 1,
            description: JSON.stringify({
              type: "array",
              msg: "smgTwoElements"
            })
          }
        },
        additionalProperties: false,
        required: ["id", "mode", "type", "operation", "questions"],
        allOf: [
          {
            if: { properties: { operation: { enum: ["mode"] } } },
            then: {
              properties: {
                questions: {
                  minItems: 3,
                  description: JSON.stringify({
                    type: "array",
                    msg: "smgModeSchema"
                  })
                }
              }
            }
          }
        ]
      },
      options: {
        type: "array",
        minItems: 1,
        items: {
          type: "string",
          minLength: 2
        }
      },
      content: {
        type: "string",
        minLength: 3
      },
      related: {
        type: "object",
        properties: {
          answer: {
            type: "string",
            minLength: 3
          },
          answers: {
            type: "array",
            items: [{ type: "integer" }, { type: "string" }, { type: "boolean" }]
          },
          name: {
            type: "string",
            minLength: 3
          },
          question: {
            type: "number",
            minimum: 0
          },
          relatedness: {
            type: "string",
            minLength: 3,
            enum: ["simple", "compound"]
          },
          type: {
            type: "string",
            minLength: 3
          }
        },
        required: ["name", "question", "relatedness"],
        additionalProperties: false
      },
      data: {
        type: "array",
        minItems: 1,
        description: JSON.stringify({
            type: "string",
            msg: "msgErrorData"
        })
    },
    },
    errorMessage: "La estructura del subformulario tiene propiedades adicionales",
    additionalProperties: false,
    required: ["name", "type", "label", "required", "inputType"]
  }
};

export const validationSubformulario = json => {
  const validate = ajv.compile(schemaSubformulario);
  const valid = validate(json);
  // if (!valid) console.log(validate.errors)
  return { valid, error: validate.errors };
};
